<template>
<div class="chapter">
<div class="inner_page">
<ul class="alternate_style">
<li><strong><a href="#/xhtml/08foreword#for">FOREWORD</a></strong></li>
<li><strong><a href="#/xhtml/09introduction#int">INTRODUCTION <span class="fontb">THE WORLD IS MY PORK CHOP</span></a></strong></li>
<li><strong><a href="#/xhtml/10chapter01#ch1">CHAPTER 1 <span class="fontb">ALL ABOUT PORK CHOPS</span></a></strong></li>
<li><strong><a href="#/xhtml/13chapter02#ch2">CHAPTER 2 <span class="fontb">THE CLASSICS</span></a></strong>
<ul class="list">
<li><strong><a href="#/xhtml/14chapter02a#ch2lev1">Chicago-Style Pork Chop Sandwiches</a></strong></li>
<li><strong><a href="#/xhtml/15chapter02b#ch2lev2">Saut<span class="serif">é</span>ed Pork Chops with Apples</a></strong></li>
<li><strong><a href="#/xhtml/16chapter02c#ch2lev3">Pineapple Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/17chapter02d#ch2lev4">Blackened Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/18chapter02e#ch2lev5">Garlic Lovers’ Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/19chapter02f#ch2lev6">Skillet-Braised Pork Chops with Vidalia Onions</a></strong></li>
<li><strong><a href="#/xhtml/20chapter02g#ch2lev7">Herb and Parmesan–Crusted Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/21chapter02h#ch2lev8">Honey-Brined Pecan-Crusted Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/22chapter02i#ch2lev9">Homemade Teriyaki Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/23chapter02j#ch2lev10">Grilled Pork Chops with Homemade BBQ Sauce</a></strong></li>
<li><strong><a href="#/xhtml/24chapter02k#ch2lev11">Southern-Fried Pork Chops</a></strong></li>
<li><strong><a href="#/xhtml/25chapter02l#ch2lev12">Dry-Rubbed Iowa Chops</a></strong></li>
<li><strong><a href="#/xhtml/26chapter02m#ch2lev13">Stand-Up Stuffed Pork Chops with Bacon and Blue Cheese</a></strong></li>
</ul>
</li>
<li><strong><a href="#/xhtml/27chapter03#ch3">CHAPTER 3 <span class="fontb">FRESH IDEAS</span></a></strong>
<ul class="list">
<li><a href="#/xhtml/28chapter03a#ch3lev1"><strong>Grilled Romaine and Pork Chopped Salad</strong></a></li>
<li><a href="#/xhtml/29chapter03b#ch3lev2"><strong>Pork Chop and Mixed Greens Salad with Raspberry Vinaigrette</strong></a></li>
<li><a href="#/xhtml/30chapter03c#ch3lev3"><strong>Sandi<span class="serif">’</span>s Asian-Inspired Pork Chop Salad</strong></a></li>
<li><a href="#/xhtml/31chapter03d#ch3lev4"><strong>Pork Chop Taco Salad with Avocado Dressing</strong></a></li>
<li><a href="#/xhtml/32chapter03e#ch3lev5"><strong>Pork Chop Wraps with Spinach and Feta Cheese</strong></a></li>
<li><a href="#/xhtml/33chapter03f#ch3lev6"><strong>Spicy Pork Chop Lettuce Wraps</strong></a></li>
<li><a href="#/xhtml/34chapter03g#ch3lev7"><strong>Pork Chop and Veggie Stir-Fry</strong></a></li>
<li><a href="#/xhtml/35chapter03h#ch3lev8"><strong>Flat Bread Pork Chop Pizza</strong></a></li>
<li><a href="#/xhtml/36chapter03i#ch3lev9"><strong>Pork Chops with Broccoli</strong></a></li>
<li><a href="#/xhtml/37chapter03j#ch3lev10"><strong>Balsamic and Vanilla<span class="serif">–</span>Glazed Pork Chops</strong></a></li>
<li><a href="#/xhtml/38chapter03k#ch3lev11"><strong>Broiled Pork Chops with Pineapple Chutney</strong></a></li>
<li><a href="#/xhtml/39chapter03l#ch3lev12"><strong>Pork Chops with Fresh Mango-Habanero Salsa</strong></a></li>
</ul>
</li>
<li><strong><a href="#/xhtml/40chapter04#ch4">CHAPTER 4 <span class="fontb">ONE-POT PORK CHOPS</span></a></strong>
<ul class="list">
<li><a href="#/xhtml/41chapter04a#ch4lev1"><strong>Pork Chop Pot Roast</strong></a></li>
<li><a href="#/xhtml/42chapter04b#ch4lev2"><strong>Slow Cooker Pork Chops</strong></a></li>
<li><a href="#/xhtml/43chapter04c#ch4lev3"><strong>Pork Chop Pepper Steak</strong></a></li>
<li><a href="#/xhtml/44chapter04d#ch4lev4"><strong>Tater Tot Pork Chop Casserole</strong></a></li>
<li><a href="#/xhtml/45chapter04e#ch4lev5"><strong>Cheesy Pork Chop Skillet Dinner</strong></a></li>
<li><a href="#/xhtml/46chapter04f#ch4lev6"><strong>Pork Chops and Dumplings</strong></a></li>
<li><a href="#/xhtml/47chapter04g#ch4lev7"><strong>Pork Chop Chili</strong></a></li>
<li><a href="#/xhtml/48chapter04h#ch4lev8"><strong>Pork Chop Gumbo</strong></a></li>
<li><a href="#/xhtml/49chapter04i#ch4lev9"><strong>Pork Chop Noodle Soup</strong></a></li>
<li><a href="#/xhtml/50chapter04j#ch4lev10"><strong>Pork Chop, Leek, and Potato Soup</strong></a></li>
<li><a href="#/xhtml/51chapter04k#ch4lev11"><strong>Ray’s Special Oven Chops</strong></a></li>
<li><a href="#/xhtml/52chapter04l#ch4lev12"><strong>Pork Chops and White Beans</strong></a></li>
</ul></li>
<li><strong><a href="#/xhtml/53chapter05#ch5">CHAPTER 5 <span class="fontb">INTERNATIONAL PORK CHOPS</span></a></strong>
<ul class="list">
<li><a href="#/xhtml/54chapter05a#ch5lev1"><strong>Pork Chop Suey</strong></a></li>
<li><a href="#/xhtml/55chapter05b#ch5lev2"><strong>Thai Pork Chops in Banana Leaves</strong></a></li>
<li><a href="#/xhtml/56chapter05c#ch5lev3"><strong>Spicy Grilled Jerk Pork Chops</strong></a></li>
<li><a href="#/xhtml/57chapter05d#ch5lev4"><strong>Mojo-Marinated Pork Chops</strong></a></li>
<li><a href="#/xhtml/58chapter05e#ch5lev5"><strong>Arroz con Puerco Chops</strong></a></li>
<li><a href="#/xhtml/59chapter05f#ch5lev6"><strong>Sangrita Pork Chops</strong></a></li>
<li><a href="#/xhtml/60chapter05g#ch5lev7"><strong>Pork Chop Guacadillas</strong></a></li>
<li><a href="#/xhtml/61chapter05h#ch5lev8"><strong>Pork Chop Carnitas</strong></a></li>
<li><a href="#/xhtml/62chapter05i#ch5lev9"><strong>Pork Chop <span class="serif">É</span>touff<span class="serif">é</span>e</strong></a></li>
<li><a href="#/xhtml/63chapter05j#ch5lev10"><strong>Pork Chops Cordon Bleu</strong></a></li>
<li><a href="#/xhtml/64chapter05k#ch5lev11"><strong>Pork Chops Saltimbocca</strong></a></li>
<li><a href="#/xhtml/65chapter05l#ch5lev12"><strong>Pork Chops Parmigiana</strong></a></li>
<li><a href="#/xhtml/66chapter05m#ch5lev13"><strong>It’s a Canadian Pork Chop, Eh!</strong></a></li>
</ul>
</li>
<li><strong><a href="#/xhtml/67chapter06#ch6">CHAPTER 6 <span class="fontb">EXTREME PORK CHOPS</span></a></strong>
<ul class="list">
<li><a href="#/xhtml/68chapter06a#ch6lev1"><strong>Pork Chop–Stuffed French Toast</strong></a></li>
<li><a href="#/xhtml/69chapter06b#ch6lev2"><strong>Doenee’s Hawaiian Pork Chop Sandwiches</strong></a></li>
<li><a href="#/xhtml/70chapter06c#ch6lev3"><strong>Buffalo Hot Chop Sandwiches</strong></a></li>
<li><a href="#/xhtml/71chapter06d#ch6lev4"><strong>Philly Cheese Chops</strong></a></li>
<li><a href="#/xhtml/72chapter06e#ch6lev5"><strong>Pig Wings with Spicy Mustard Dipping Sauce</strong></a></li>
<li><a href="#/xhtml/73chapter06f#ch6lev6"><strong>Pastrami Pork Chops</strong></a></li>
<li><a href="#/xhtml/74chapter06g#ch6lev7"><strong>Horseradish-Crusted Pork Chops</strong></a></li>
<li><a href="#/xhtml/75chapter06h#ch6lev8"><strong>Grilled Coffee-Crusted Pork Chops</strong></a></li>
<li><a href="#/xhtml/76chapter06i#ch6lev9"><strong>Deep-Fried Pork Chops</strong></a></li>
<li><a href="#/xhtml/77chapter06j#ch6lev10"><strong>Jalape<span class="serif">ñ</span>o Pork Chops</strong></a></li>
</ul>
</li>
<li><strong><a href="#/xhtml/78index#ind">INDEX</a></strong></li>
<li><strong><a href="#/xhtml/80author#author">ABOUT THE AUTHOR</a></strong></li>
</ul>
<div class="image_wrap">
<p class="image"><a id="page_8"></a><a id="page_9"></a><img alt="image" class="horizontal" src="images/f0008-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07-contents.vue?d4adff0a